import React from "react";
import DashboardLayout from "../../layouts/Dashboard";
import { useHistory } from "react-router-dom";
import useReload from "../../hooks/useReload";
import PlanDocumentCRUDTable from "../../components/CRUD/Tables/PlanDocumentCRUDTable";
import { PLAN_DOCUMENT_ROUTE } from "../../routes";
import { planDocumentCRUD } from "../../http";
import { hasPlanRole, isPlanAdmin } from "../../models/planRoles";
import { planStateIds } from "../../models/planStateIds";

const PlanList = () => {
  const history = useHistory();
  const { reload, reloadValue } = useReload();

  const canCreate = isPlanAdmin() || hasPlanRole("planning");
  const canDelete = isPlanAdmin() || hasPlanRole("planning");

  const detailAction = (id) => {
    history.push(PLAN_DOCUMENT_ROUTE(id));
  };

  const editAction = (id) => {
    history.push(PLAN_DOCUMENT_ROUTE(id));
  };

  const deleteAction = async (id) => {
    try {
      await planDocumentCRUD.delete(id);
      reload();
    } catch (err) {
      alert(err);
    }
  };

  return (
    <DashboardLayout>
      <PlanDocumentCRUDTable
        onClickDetailsButton={detailAction}
        onClickEditButton={editAction}
        onClickDeleteButton={canDelete ? deleteAction : null}
        editVisibleFunc={(record) =>
          Number(record?.stateId) === planStateIds.created ||
          Number(record?.stateId) === planStateIds.inProgressNce
        }
        deleteVisibleFunc={(record) =>
          Number(record?.stateId) === planStateIds.created
        }
        reloadValue={reloadValue}
        disableCreateButton={!canCreate}
      />
    </DashboardLayout>
  );
};

export default PlanList;
